import { Button, Card, Inline } from "@swot/base-components";
import type { ComplaintAllowedActionDto } from "../../../types/complaint.types.js";

export function CmtsAllowedActionsPanel({ actions, busyActionCode, onAction }: {
  readonly actions?: readonly ComplaintAllowedActionDto[] | undefined;
  readonly busyActionCode?: string | undefined;
  readonly onAction: (actionCode: string, action: ComplaintAllowedActionDto) => void | Promise<void>;
}) {
  const rows = (actions ?? []).filter((action) => action.allowed);
  return (
    <Card>
      <div className="space-y-5">

        {/* Header */}
        <div className="border-b pb-4">
          <h2 className="text-xl font-bold text-slate-800">
            Workflow Actions
          </h2>

          <p className="mt-1 text-sm text-slate-500">
            Only backend-authorized actions are available for this complaint.
          </p>
        </div>

        {/* Empty State */}
        {rows.length === 0 ? (
          <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center">

            <div className="text-4xl">
              🔒
            </div>

            <p className="mt-3 font-medium text-slate-700">
              No workflow actions available
            </p>

            <p className="mt-1 text-sm text-slate-500">
              There are currently no actions allowed for this complaint.
            </p>

          </div>
        ) : (

          <div className="grid gap-3">

            {rows.map((action) => (

              <Button
                key={action.actionCode}
                className="w-full justify-start rounded-xl border border-slate-200 bg-white px-5 py-4 text-left shadow-sm transition-all hover:border-blue-500 hover:bg-blue-50 hover:shadow-md"
                label={
                  busyActionCode === action.actionCode
                    ? "⏳ Processing..."
                    : `⚡ ${action.displayLabel}`
                }
                disabled={busyActionCode === action.actionCode}
                onClick={() => onAction(action.actionCode, action)}
              />

            ))}

          </div>

        )}

      </div>
    </Card>
  );
}
